import React from 'react';
import PropTypes from 'prop-types';
import CallToAction, { ctaPropTypes } from 'Components/CallToAction';
import ConsumptionData from 'Components/ConsumptionData';
import { Container, Row, Col } from 'Components/Grid';
import classNames from 'classnames/bind';
import styles from './styles.scss';
import { getGivenBackground } from 'Utils/getColor';
import Typography, { headlinePropTypes } from 'Components/Typography';
import Icon, { icons } from 'Components/Icon';

const cx = classNames.bind(styles);

const IntroText = ({
  background = 'medium',
  consumptionText,
  contentAlignment = 'center',
  cta1,
  cta2,
  deeplinkId,
  headline,
  iconSet1,
  iconSet2,
  onOpenContact,
  bodyText,
}) => (
  <div className={cx(background || getGivenBackground('white'))} id={deeplinkId}>
    <Container>
      <div className={cx(styles.root)}>
        <Row align="center">
          <Col cols={12} m={10} l={8} align={contentAlignment}>
            <div className={cx(styles.content, styles[contentAlignment])}>
              {headline && (
                <Typography.Headline
                  className={styles.title}
                  additionalAriaLabelText={consumptionText}
                  {...headline}
                />
              )}
              {iconSet1 && iconSet1.length > 0 && (
                <div className={cx(styles.iconSet, styles[contentAlignment])}>
                  {iconSet1.slice(0, 3).map((name, index) => (
                    <div key={index}>
                      <Icon name={name} />
                    </div>
                  ))}
                </div>
              )}
              {bodyText && (
                <p className={styles.text} dangerouslySetInnerHTML={{ __html: bodyText }} />
              )}
              {iconSet2 && iconSet2.length > 0 && (
                <div className={cx(styles.iconSet, styles[contentAlignment])}>
                  {iconSet2.slice(0, 3).map((name, index) => (
                    <div key={index}>
                      <Icon name={name} />
                    </div>
                  ))}
                </div>
              )}
              {(cta1 || cta2) && (
                <div className={cx(styles.cta, styles[contentAlignment])}>
                  {cta1 && (
                    <CallToAction
                      {...cta1}
                      onOpenContact={onOpenContact}
                      light={background === 'dark'}
                    />
                  )}
                  {cta2 && (
                    <CallToAction
                      {...cta2}
                      onOpenContact={onOpenContact}
                      light={background === 'dark'}
                    />
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </Container>
    {consumptionText && (
      <ConsumptionData
        ariaHidden={true}
        consumptionText={[consumptionText]}
        style={background === 'dark' ? { color: 'white' } : undefined}
      />
    )}
  </div>
);

IntroText.propTypes = {
  background: PropTypes.string, //oneOf(['dark', 'medium', 'light']), // default medium
  consumptionText: PropTypes.string,
  contentAlignment: PropTypes.oneOf(['left', 'center', 'right']), // default center
  cta1: PropTypes.shape(ctaPropTypes),
  cta2: PropTypes.shape(ctaPropTypes),
  deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  headline: PropTypes.shape(headlinePropTypes),
  iconSet1: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(icons))),
  iconSet2: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(icons))),
  onOpenContact: PropTypes.func,
  bodyText: PropTypes.string,
};

export default IntroText;
